import { render, staticRenderFns } from "./recognizeIndex.vue?vue&type=template&id=5852576c&scoped=true"
import script from "./recognizeIndex.vue?vue&type=script&lang=js"
export * from "./recognizeIndex.vue?vue&type=script&lang=js"
import style0 from "./recognizeIndex.vue?vue&type=style&index=0&id=5852576c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5852576c",
  null
  
)

export default component.exports